import { LeadResult, LeadResultType } from "../../../../dtos/LeadResult";

/** A lead result for medical non-candidacy. */
class MedicalNonCanLeadResult extends LeadResult {
  /**
   * @param customerId - The ID of the customer for whom the lead result is being created.
   * @param opportunityId - The ID of the opportunity associated with the lead result.
   * @param disqualifyingReasonId - The ID of the disqualifying reason for medical non-candidacy.
   */
  constructor(customerId: string, opportunityId: string, disqualifyingReasonId: string) {
    super(customerId, opportunityId, LeadResultType.ObxNonCandidateMedical, undefined);
    this.disqualifyingReasons = { ...this.disqualifyingReasons, [disqualifyingReasonId]: true };
  }
}

export default MedicalNonCanLeadResult;
